export default __webpack_public_path__ + "static/media/market4.1bbdf4b5.png";